import { ListPageShell } from "@crm/ui/components/shared";
import { PageHeader } from "@crm/ui/components/shared/page-header";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { CoursesTab } from "./-components/courses-tab";
import { LessonsTab } from "./-components/lessons-tab";
import { ModulesTab } from "./-components/modules-tab";
import { ResourcesTab } from "./-components/resources-tab";

/**
 * 课程管理页面
 */
export const Route = createFileRoute("/_protected/review-course/admin/")({
  head: () => ({
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const [activeTab, setActiveTab] = useState<"courses" | "modules" | "lessons" | "resources">(
    "courses",
  );

  return (
    <ListPageShell>
      <PageHeader description="管理课程、模块、课时和资源" title="课程管理" />
      <main className="mt-8">
        {/* Tabs */}
        <div className="mb-8 flex gap-2 border-border border-b-2">
          {[
            { id: "courses", label: "课程" },
            { id: "modules", label: "模块" },
            { id: "lessons", label: "课时" },
            { id: "resources", label: "资源" },
          ].map((tab) => (
            <button
              className={`border border-border border-b-0 px-6 py-3 font-bold font-mono transition-colors ${
                activeTab === tab.id ? "bg-ink text-white" : "bg-white hover:bg-muted"
              }`}
              key={tab.id}
              onClick={() =>
                setActiveTab(tab.id as "courses" | "modules" | "lessons" | "resources")
              }
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        {activeTab === "courses" && <CoursesTab />}
        {activeTab === "modules" && <ModulesTab />}
        {activeTab === "lessons" && <LessonsTab />}
        {activeTab === "resources" && <ResourcesTab />}
      </main>
    </ListPageShell>
  );
}
